import React from 'react';
import classNames from 'clsx';
import { gradientFor, nameInitials } from '@/containers/Conversaciones/avatar';

export interface ConversationAvatarData {
  conversationId: number;
  name: string;
  channel: 'web' | 'whatsapp';
  /** Sin nombre ni ficha: círculo gris, como en la bandeja. */
  known: boolean;
}

const WA_PATH =
  'M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2Zm0 1.8a8.2 8.2 0 1 1-4.2 15.3l-.3-.2-3 .8.8-2.9-.2-.3A8.2 8.2 0 0 1 12 3.8Zm-3.3 4.4c-.2 0-.5 0-.7.3-.3.3-1 1-1 2.3s1 2.7 1.2 2.9c.1.2 2 3.2 5 4.3 2.4.9 2.9.8 3.5.7.5-.1 1.7-.7 1.900-1.4.2-.7.2-1.2.2-1.4l-.5-.3-1.8-.9c-.2-.1-.4-.1-.6.1l-.8 1c-.1.2-.3.2-.6.1-.3-.1-1.1-.4-2.1-1.3-.8-.7-1.300-1.5-1.5-1.8-.1-.3 0-.4.1-.5l.4-.5.3-.4v-.5l-.8-2c-.2-.5-.4-.5-.6-.5h-.6Z';
const BUBBLE_PATH = 'M2 3.5A2 2 0 0 1 4 1.5h8a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H6.5L3 14.5v-3H4a2 2 0 0 1-2-2Z';

/**
 * La foto del cliente en la campanita (maqueta «Avisos»): iniciales sobre el mismo degradé que en la
 * bandeja y el canal abajo a la derecha. Sin cargar Conversaciones.
 */
export const ConversationAvatar: React.FC<{ data: ConversationAvatarData }> = ({ data }) => (
  <span
    className={classNames(
      'relative inline-grid h-10 w-10 shrink-0 place-items-center rounded-full text-fs-13 font-semibold',
      data.known ? 'text-white' : 'bg-frost-hair-stronger text-frost-ink-soft'
    )}
    style={data.known ? { background: gradientFor(data.conversationId) } : undefined}
    aria-hidden
  >
    {nameInitials(data.name, data.known)}
    <span
      className={classNames(
        'absolute -right-[3px] -bottom-[3px] grid h-[18px] w-[18px] place-items-center rounded-full text-white ring-2 ring-frost-card',
        data.channel === 'whatsapp' ? 'bg-brand-whatsapp' : 'bg-frost-brand'
      )}
    >
      <svg
        viewBox={data.channel === 'whatsapp' ? '0 0 24 24' : '0 0 16 16'}
        className="h-2.5 w-2.5"
        fill="currentColor"
        aria-hidden
        focusable="false"
      >
        <path d={data.channel === 'whatsapp' ? WA_PATH : BUBBLE_PATH} />
      </svg>
    </span>
  </span>
);
